export type TimePeriod =
  | 'all_time'
  | 'this_week'
  | 'last_week'
  | 'this_month'
  | 'last_month'
  | 'this_quarter'
  | 'last_quarter'
  | 'this_year';

export const TIME_PERIOD_OPTIONS = [
  { value: 'all_time', label: 'All Time' },
  { value: 'this_week', label: 'This Week' },
  { value: 'last_week', label: 'Last Week' },
  { value: 'this_month', label: 'This Month' },
  { value: 'last_month', label: 'Last Month' },
  { value: 'this_quarter', label: 'This Quarter' },
  { value: 'last_quarter', label: 'Last Quarter' },
  { value: 'this_year', label: 'This Year' },
];

export function getDateRange(period: TimePeriod): { start: string; end: string } {
  const now = new Date();
  let start: Date;
  let end: Date;

  switch (period) {
    case 'all_time': {
      start = new Date(2000, 0, 1);
      end = new Date(now);
      break;
    }
    case 'this_year': {
      start = new Date(now.getFullYear(), 0, 1);
      end = new Date(now);
      break;
    }
    case 'this_week': {
      const day = now.getDay();
      start = new Date(now);
      start.setDate(now.getDate() - day);
      end = new Date(now);
      break;
    }
    case 'last_week': {
      const day = now.getDay();
      start = new Date(now);
      start.setDate(now.getDate() - day - 7);
      end = new Date(start);
      end.setDate(start.getDate() + 6);
      break;
    }
    case 'this_month': {
      start = new Date(now.getFullYear(), now.getMonth(), 1);
      end = new Date(now);
      break;
    }
    case 'last_month': {
      start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      end = new Date(now.getFullYear(), now.getMonth(), 0);
      break;
    }
    case 'this_quarter': {
      const qMonth = Math.floor(now.getMonth() / 3) * 3;
      start = new Date(now.getFullYear(), qMonth, 1);
      end = new Date(now);
      break;
    }
    case 'last_quarter': {
      const qMonth = Math.floor(now.getMonth() / 3) * 3;
      start = new Date(now.getFullYear(), qMonth - 3, 1);
      end = new Date(now.getFullYear(), qMonth, 0);
      break;
    }
  }

  return {
    start: formatDate(start),
    end: formatDate(end),
  };
}

function formatDate(d: Date): string {
  return d.toISOString().slice(0, 10);
}

/** Returns SOQL WHERE fragment for a Date field: "field >= 2024-01-01 AND field <= 2024-01-31" */
export function soqlDateFilter(field: string, period: TimePeriod): string {
  const { start, end } = getDateRange(period);
  return `${field} >= ${start} AND ${field} <= ${end}`;
}

/** Returns SOQL WHERE fragment for a DateTime field using T00:00:00Z format */
export function soqlDateTimeFilter(field: string, period: TimePeriod): string {
  const { start, end } = getDateRange(period);
  return `${field} >= ${start}T00:00:00Z AND ${field} <= ${end}T23:59:59Z`;
}
